import gql from 'graphql-tag'

export const fetchHPCartQuery = gql(`
query ($cart_id: String!) {
  cart(
      cart_id: $cart_id
  ) {
    free_beer_active
    delivery_date
    delivery_method
    id
    ship_to_id
    grand_total_your_price_details
    payer_details {
      payername
      street
      city
      country
      zipcode
      sap_id
      identification_no
      taxvat
    }
    outlet_details {
      payer_name
      outlet_name
      street
      city
      country
      province
      postalcode
      sap_id
    }
    items {
      id
      uid
      is_free_beer
      product {
        hectolitres_fe
        additional_weight
        special_offer_details{
          max_purchasable_qty
          valid_from
          valid_to
          deliverable_from
          deliverable_to
          deliverable_flag
          layer_error_flag
        }
        low_stock_pl {
          is_lowstock
          out_of_stock
          rotation_day
          quantity
        }
        sku
        name
        catalog_product_name
        image {
          url
        }
      }
      quantity_total
    }
    cart_prices {
      grand_total_price
      grand_total_price_with_vat
      total_discount_basic
      total_discount_cash
      total_discount_packaging
      total_discount_promotional
      free_beer_total
      summary
    }
    progress_bar_data {
    color
    sSpecialOfferDeliverableFlag
    sSpecialOfferLayerFlag
    sHighMarginAvgValue
    sHighMarginFlag
    cashDiscount  {
      cashamount
      isactive
      canshow
    }
    brand_progressbar {
        brand
        sub_brand
        hectolitres
        cases
      }
      isFullTruck
      isHalfTruck
      isSmallOrder
      isCheckoutEnable
      boolIncludeWeightCalculation
      iMinimumOrderPallet
      iMaximumOrderPallet
      iMinimumOrderWeight
      iMaximumOrderWeight
      sOutletDeliveryMethod
      iTotalCartWeight
      iTotalCartPalletQty
      iTotalCartVoulume
      iTotalFreeItems
      status
      can_show_layer_notice
      
    }
  }
}
`)
